import spa from "./login.vue";

new Vue({
  el: '#app-spa-target',
  render: h => h(spa)
});